export class TrsReferenceVoucherByVoucherKindFilterInfo {
  public Id?: number;
  public ReferencedVoucherKindId?: number;
  public VoucherKindId: number;
  public DetailLedgerId?: number;
  public DurationKindCode?: number;
  public TreasuryDetailLedgerId?: number;
  public VoucherDate: Date;
  public BranchId?: number;
  public FiscalYearId: number;
  public ConcernId?: number;
  public ConcernCode?: number;
  public ConcernTitle: string;
  public InvVoucherKindId?: number;
  public IsWarehouse?: boolean;
}
